const getDb = () => {
  return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;;
}

export const dbOpen = () => {
  return new Promise(resolve => {
    const indexedDB = getDb();
    const open = indexedDB.open("jikiwi", 3);

    open.onupgradeneeded = function () {
      const db = open.result;

      try {db.deleteObjectStore("config");} catch (e) {}
      try {db.deleteObjectStore("transactions");} catch (e) {}
      try {db.deleteObjectStore("i18n");} catch (e) {}

      db.createObjectStore("config");
      db.createObjectStore("transactions", {keyPath: "id"});
      db.createObjectStore("i18n", {keyPath: "ns"});
    };

    open.onsuccess = () => resolve(open.result);
  });
}

export const dbGet = (store, what) => {
  return new Promise(resolve => {
    const query = store.get(what);

    query.onsuccess = () => {
      resolve(query.result);
    };
  });
}

export const dbGetAll = store => {
  return new Promise(resolve => {
    const query = store.getAll();

    query.onsuccess = () => {
      resolve(query.result);
    };
  });
}

export const dbClear = store => {
  return new Promise(resolve => {
    const query = store.clear();

    query.onsuccess = () => {
      resolve();
    };
  });
}

export const dbDelete = () =>{
  getDb().deleteDatabase("jikiwi");
}
